// Re-export the api instance as axiosInstance for backward compatibility
import api from '../services/api.js';

const axiosInstance = api;

export default axiosInstance;
